<template>
  <add-product-popup
    ref="add_product_el"
    @add-by="addProduct"
    :brand_name="storefront?.merchant_display_name"
    :type="tag_product_type"
  />
  <tag-product-drawer
    ref="tag_product_drawer_el"
    :storefront="storefront"
    :tag_type="tag_product_type"
    :tag_content_id="tag_product_content_id"
    :tagged_ids="tagged_ids"
    @tagged="taggedProducts"
  />

</template>

<script setup>
import { getCurrentInstance, onMounted, ref } from 'vue';
import AddProductPopup from './AddProductPopup.vue';
import TagProductDrawer from './TagProductDrawer.vue';
import { useNotification } from '@/components/ui/notification';

const app = getCurrentInstance();
const store = app.appContext.config.globalProperties.$store;
const event = app.appContext.config.globalProperties.EventBus;
const ajax = app.appContext.config.globalProperties.$ajax;
const projectName = ref(app.appContext.config.globalProperties.$ProjectName);
const tag_product_type = ref('storefront'); // 'post' or 'collection' or 'storefront'
const add_product_el = ref(null);
const tag_product_drawer_el = ref(null);
const tag_product_content = ref({});
const tag_product_content_id = ref(0);
const tagged_ids = ref([]);
const storefront = store.state.user_data.merchant_account;
const { openNotBottom } = useNotification();


const addProduct = (type) => {
  add_product_el.value.close();
  tag_product_drawer_el.value.open(type);
};

const taggedProducts = async (products) => {
  tag_product_drawer_el.value.showLoading(true);

  if (projectName.value !== 'sephora') {
    products.forEach((product) => {
      // console.log('tag product before', product);
      if (product.total_color_size_map && product.total_color_size_map.filter(item => item.is_selected).length > 0) {
        product.total_color_size_map.forEach((item) => {
          if (item.is_selected) {
            const clone_product = JSON.parse(JSON.stringify(product));
            clone_product.total_color_size_map = [];
            clone_product.id = item.product_id;
            products.push(clone_product);
          }
        });

        // remove this product from array
        products.splice(products.indexOf(product), 1);
      }
    });

      // console.log('tag products after', products);
      // return;
  }

  let rows = null;
  let api_url = '';
  switch (tag_product_type.value) {
    case 'collection':
      api_url = '/storefront-curation/add-curation-collection-item';
      rows = {};
      rows.curation_collection_ids = [tag_product_content_id.value];
      rows.product_ids = [];
      products.forEach((product) => {
        if (product.total_color_size_map && product.total_color_size_map.filter(item => item.is_selected).length > 0) {
          product.total_color_size_map.forEach((item) => {
            if (item.is_selected) rows.product_ids.push(item.product_id);
          });
        } else {
          rows.product_ids.push(product.id);
        }
      });
      break;
    case 'storefront':
      api_url = '/storefront-curation/add-curation-product';
      rows = [];

      //console.log('tag products!!!', products);
      // return;

      products.forEach((product) => {
        //console.log('product??',product)
        const product_ids = [];
        let creator_ids = [];
        let tag_ids = [];
        let collection_ids = [];
        let is_apply_to_all_creators = false;

        if (product.total_color_size_map && product.total_color_size_map.filter(item => item.is_selected).length > 0) {
          product.total_color_size_map.forEach((item) => {
            if (item.is_selected) product_ids.push(item.product_id);
          });
        } else {
          product_ids.push(product.id);
        }

        is_apply_to_all_creators = (product.post_to.data[0] && product.post_to.data[0].name === 'All');

        if (!is_apply_to_all_creators) {
          product.post_to.data.forEach((item) => {
            if (item.motom_user_id) {
              creator_ids.push(item.id);
            } else {
              tag_ids.push(item.id);
            }
          });
        }

        product.curation_collections.forEach((item) => {
          collection_ids.push(item.id);
        });

        const form_data = {
          product_ids: product_ids,
          is_feature: product.permission.indexOf('allow_feature') !== -1 ? 1 : 0,
          is_schedule: product.status_string === 'scheduled' ? 1 : 0,
          allow_creator_remove: product.permission.indexOf('allow_remove') !== -1 ? 1 : 0,
          notify_creator_on_publish: product.notify_creators ? 1 : 0,
          apply_to_all_creators: is_apply_to_all_creators ? 1 : 0,
          status: product.status_string === 'scheduled' ? 'active' : product.status_string,
          anchor_creator_ids: creator_ids,
          tag_ids: tag_ids,
          curation_collection_ids: collection_ids,
          is_sponsored_disclosure_enabled: product.is_sponsored_disclosure_enabled ? 1 : 0,
          sponsored_disclosure_name: product.sponsored_disclosure_name || 'Promoted'
        };

        if (product.scheduled_start_enabled && product.scheduled_start.val) {
          form_data.publish_datetime = product.scheduled_start.val;
        }

        if (product.scheduled_end_enabled && product.scheduled_end.val) {
          form_data.disable_datetime = product.scheduled_end.val;
        }

        rows.push(form_data);
      }); 

      rows = JSON.stringify(rows);
      break;
  }

  const res = await ajax.post(api_url, rows);
  tag_product_drawer_el.value.showLoading(false);
  //console.log('tag products res', res);

  try {
    if(tag_product_type.value === 'storefront'){
      res.data.data.forEach(item => {
        const match = JSON.parse(rows).find(r => JSON.stringify(r.product_ids) === JSON.stringify(item.product_ids))
        console.log('match',match )
        if (match) item.status = match.status
      })
      await PublishProduct(res.data.data);
    }
    event.emit('set-not-empty');
    event.emit('refresh-storefront-collection-table');
    event.emit('refresh-storefront-product-table');

    // Trigger queue update event
    event.emit('ready-queue-update');
    if (res.data && res.data.error) {
      openNotBottom(res.data.error.message || 'Failed to tag products, please try again.', 'error');
      return;
    }


    if(tag_product_type.value === 'collection'){
      if(!new URLSearchParams(window.location.search).has('id')){
        // event.emit('open-collection-detail', {
        //   content_id: tag_product_content_id.value,
        //   is_edit: false,
        //   row: tag_product_content.value
        // });
        window.localStorage.setItem('storefront_collection_detail_row', JSON.stringify(tag_product_content.value));
        const newUrl = `${location.pathname}?id=${tag_product_content_id.value}`;
        history.replaceState(null, '', newUrl); 
      }
    
    }
  } catch (e) {
    openNotBottom('Failed to tag products, please try again.', 'error');
    return;
  }

  tag_product_drawer_el.value.close();

  switch (tag_product_type.value) {
    // no post type for now
    // case 'post':
    //   openNotBottom(`Product${obj.length !== 1 ? 's' : ''} tagged to post successfully`, 'success');
    //   event.emit('refresh-post-products', { type: 'post', post_id: obj.id });
    //   break;
    case 'collection':
      openNotBottom(`Product${products.length !== 1 ? 's' : ''} tagged to collection successfully`, 'success');
      event.emit('refresh-tagged-products', { type: 'collection', collection_id: tag_product_content_id.value });
      event.emit('refresh-storefront-collection-table');
      event.emit('refresh-storefront-product-table');
      break;
    case 'storefront':
      openNotBottom(`Product${products.length !== 1 ? 's' : ''} tagged successfully`, 'success');
      event.emit('refresh-storefront-product-table');
      event.emit('refresh-storefront-collection-table');
      event.emit('refresh-storefront-product-table');
      break;
  }

  
};

const PublishProduct = async (rows) => {
  let new_row= rows.filter(e=>e.status ==='active');
  
  try {
      const params_data = {
        'curation_product_ids[]': new_row.map(e=>{return e.curation_product_id}),
      };
      if(new_row.length > 0){
        setTimeout(async()=>{
          await ajax.post('/storefront-curation/publish-curation-product',  params_data , {
            headers: { 'Content-Type': 'multipart/form-data' },
          });
          
          // Trigger queue update event
          event.emit('ready-queue-update');
        },10)

      }

  } catch (error) {
    console.error('Publish product failed:', error);
    openNotBottom('Publish failed', 'error');
  } 
};

onMounted(() => {
  // addProduct('catalog'); // url

  event.on('tag-products', (obj) => {
    tag_product_type.value = obj.which;
    tag_product_content_id.value = obj.id || 0;
    tag_product_content.value=obj||{};
    setTimeout(() => {
      if (add_product_el.value) add_product_el.value.open();
    }, 1);
  });
});
</script>
<style lang="scss">
//tag
.el-tag {
  border: none;
  font: var(--medium-12);
  padding: 2px 4px;
  height: auto;

  &.green {
    background-color: var(--Green-10);
    color: var(--Text-primary);
  }

  &.yellow {
    background-color: var(--Yellow-10);
    color: var(--Text-primary);
  }

  &.gray {
    background-color: var(--Neu-20);
    color: var(--Text-primary);
  }

  &.red {
    background-color: var(--Red-10);
    color: var(--Text-primary);
  }

  .el-tag__content {
    display: inline-flex;
    align-items: center;

    svg {
      height: 10px;
      width: 10px;
      margin-left: 6px;
    }
  }
}
.alert-modal {
  padding: 24px;

  i {
    display: block;
    height: 68px;
    width: 68px;
    margin: 0 auto 24px;
    color: var(--Blue-30);

    svg {
      display: block;
      height: 100%;
      width: 100%;
    }
  }

  h2 {
    font: var(--medium-18);
    text-align: center;
    margin-bottom: 24px;
    color: var(--Black-100);
  }

  .el-button {
    margin: 0 auto;
    min-width: 90px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  footer {
    text-align: center;
  }
}

.alert-modal-2 {
  .content {
    text-align: left;

    h2 {
      font: var(--medium-18);
      text-align: left;
      margin-bottom: 12px;
      color: var(--Text-primary);
    }

    p {
      padding: 0 0 36px;
      text-align: left;
    }

    & + footer {
      display: flex;
      justify-content: flex-end;

      .el-button {
        margin: 0;
      }

      .el-button--text {
        margin-right: 16px;
        text-align: center;

        &:hover {
          background-color: var(--Neu-10);
        }
      }

      // .el-button--primary {
      //   flex: 1;
      // }
    }
  }

  // .el-button + .el-button {
  //   flex: 1;
  // }
}
</style>
